/**
 * LCP (Largest Contentful Paint) Optimizer
 * Setzt fetchpriority="high" für kritische Above-the-Fold Bilder
 * 
 * Performance-Optimierung für PageSpeed Insights
 */

(function () {
  'use strict';

  /**
   * Setzt fetchpriority="high" für LCP-Bilder
   */
  function optimizeLCPImages() {
    // Finde alle Bilder mit der Klasse 'lcp-image'
    const lcpImages = document.querySelectorAll('img.lcp-image');

    lcpImages.forEach(function (img) {
      // Setze fetchpriority="high" für bessere LCP-Performance
      img.setAttribute('fetchpriority', 'high');

      // Stelle sicher, dass loading="eager" gesetzt ist
      if (img.getAttribute('loading') !== 'eager') {
        img.setAttribute('loading', 'eager');
      }
    });


  }

  /**
   * Führe Optimierung so früh wie möglich aus
   */
  if (document.readyState === 'loading') {
    // DOM wird noch geladen - warte auf DOMContentLoaded
    document.addEventListener('DOMContentLoaded', optimizeLCPImages);
  } else {
    // DOM ist bereits geladen - führe sofort aus
    optimizeLCPImages();
  }
})();

